module.exports = __webpack_public_path__ + "img/6.ae57c85f.png";